import React from 'react'

export default function DrugStatement() {
  return (
    <div>02DrugStatement</div>
  )
}
